import { createRoot } from "react-dom/client";
import { Coverages } from "../coverages/Coverages";

export const initCoverages = () => {
  const appMount = document.getElementById("coverages");

  if (appMount) {
    const root = createRoot(appMount);
    root.render(<Coverages />);
  }
};
